module.exports = __webpack_public_path__ + "img/sunshine_coast_naming.7b49c9dc.jpg";